import React from 'react';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';

type Props = {
    busy: boolean,
    searchName: string,
    onRemove: () => void,
    onClose: () => void,
};

export const RemoveSearchModal = ({busy, searchName, onRemove, onClose}: Props) => (
    <>
        <DialogHeader onClose={onClose}>
            Remove Search
        </DialogHeader>
        <DialogMain style={{padding: 24}}>
            Remove <b>{searchName}</b> search?
        </DialogMain>
        <DialogFooter>
            <Group>
                <Button busy={busy} variant="Type.PRIMARY" onClick={onRemove}>
                    Remove Search
                </Button>
                <Button variant="Type.SECONDARY" onClick={onClose}>
                    Cancel
                </Button>
            </Group>
        </DialogFooter>
    </>
);
